import { getUrlAndParams } from "./helpers";

export function isEmbedPlayerMode(): boolean {
  const { params } = getUrlAndParams();
  return params.has("embed");
}
